import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, ShadowBox } from '@components/Restyle';
import { PopupStatusItem } from '@components/Web/PopupStatusItem.web';

const POPUP_WIDTH = 175;

export type ProjectsStatusPopupProps = {
  onPressActiveProjects?: (newTitle: string) => void;
  onPressArchiveProjects?: (newTitle: string) => void;
};

export const ProjectsStatusPopup: React.FC<ProjectsStatusPopupProps> = ({
  onPressActiveProjects,
  onPressArchiveProjects,
}) => {
  const { t } = useTranslation('models');

  return (
    <ShadowBox
      flex={1}
      width={POPUP_WIDTH}
      alignItems='center'
      justifyContent='center'
      borderRadius='xs'
      variant='base'
      backgroundColor='white'>
      <Box marginVertical='s'>
        <PopupStatusItem
          title={t('projects.buttons.activeProjects')}
          icon='RefreshCcw'
          width={POPUP_WIDTH}
          onPress={() => {
            onPressActiveProjects?.(t('projects.buttons.activeProjects'));
          }}
        />
        <PopupStatusItem
          title={t('projects.buttons.archivedProjects')}
          icon='Archive'
          width={POPUP_WIDTH}
          onPress={() => {
            onPressArchiveProjects?.(t('projects.buttons.archivedProjects'));
          }}
        />
      </Box>
    </ShadowBox>
  );
};
